export const actionTypes = {
  LOGIN: 'auth/LOGIN',
  LOGOUT: 'auth/LOGOUT',
  NEW_PASSWORD_REQUIRED: 'auth/NEW_PASSWORD_REQUIRED',
  FORGET_PASSWORD: 'auth/FORGET_PASSWORD',
} as const;
